import { AddBusinessDetailsPrompt } from "@/components/AddBusinessDetailsPrompt";
import PageLoader from "@/components/ui/PageLoader";
import PageTransition from "@/components/ui/PageTransition";
import { Button } from "@/components/ui/button/button";
import { useAuth } from "@/context/auth-context";
import useGetCreditCards from "@/features/credit-cards/useGetCreditCards";
import { businessDetailsCreateRoute } from "@/router";
import { useLoaderData, useNavigate, useParams } from "@tanstack/react-router";
import { useState } from "react";
import ReviewDepositContainer from "./review-deposit/ReviewDepositContainer";
import SelectDepositAmount from "./select-amount/SelectAmount";

const DepositAmountPage = () => {
	const [pageStep, setPageStep] = useState<
		"enter-amount" | "review-and-transfer"
	>("enter-amount");
	const [amount, setAmount] = useState(0);
	const [promo, setPromo] = useState<string>("");
	const { user } = useAuth();
	const { cardId } = useParams({ from: "/main/deposit/$cardId/amount" });
	const navigate = useNavigate();
	const {
		user: { guest_business_details },
	} = useLoaderData({ from: "/main" });
	const { location_id } = useLoaderData({ from: "__root__" });
	const creditCardQuery = useGetCreditCards({
		guestId: user.id,
		locationId: location_id,
	});

	if (guest_business_details.length === 0) {
		return (
			<AddBusinessDetailsPrompt>
				<Button
					type="button"
					className="w-full"
					onClick={() =>
						navigate({
							to: businessDetailsCreateRoute.to,
							search: {
								callback: "/main/deposit",
							},
						})
					}
				>
					Add business details
				</Button>
			</AddBusinessDetailsPrompt>
		);
	}

	return (
		<PageLoader query={creditCardQuery}>
			{(creditCards) => {
				const selectedCard = creditCards.find(
					(card) => card.id.toString() === cardId,
				);

				if (!selectedCard) {
					throw new Error("Card not found");
				}

				return (
					<div className="">
						{pageStep === "enter-amount" ? (
							<PageTransition>
								<SelectDepositAmount
									promo={promo}
									onClose={() => {
										navigate({
											to: "/main/deposit",
										});
									}}
									onBack={() => {
										history.back();
									}}
									locationId={location_id}
									defaultAmount={amount}
									onContinue={(nextAmount, nextPromo) => {
										setAmount(nextAmount);
										setPromo(nextPromo);
										setPageStep("review-and-transfer");
									}}
									selectedCard={selectedCard}
								/>
							</PageTransition>
						) : (
							<div className="kashu-container h-[100dvh] max-h-[100dvh] py-4">
								<ReviewDepositContainer
									amount={amount}
									selectedCard={selectedCard}
									guestId={user.id}
									cardId={cardId}
									locationId={location_id}
									onBack={() => setPageStep("enter-amount")}
									promo={promo}
								/>
							</div>
						)}
					</div>
				);
			}}
		</PageLoader>
	);
};

export default DepositAmountPage;
